import scrollViewport from '../utils/scroll-viewport';
import '../utils/jquery.animateCss';

const advantageCatalog={
    'advantage-tem':'<h4>团队优势</h4>'+
                    '<p class="txt-info">1.将业界先进经验和解决方案同本行需求和具体条件相结合，星耀蓝图是架构咨询服务团队独有的特殊能力；</p>'+
                    '<p>2.以前瞻性视角结合本土实际经验，深入分析每个客户的具体情况，提出务实可行、有针对性的、可落地的解决方案和咨询建议；</p>'+
                    '<p>3.项目团队成员具有丰富的银行咨询实施项目经验，具有较强的基线梳理、现状诊断、架构规划设计、系统建设咨询能力。</p>',
    'advantage-exp':'<h4>行业先进经验</h4>'+
                    '<p class="txt-info">长期积累的咨询服务及实施项目案例，为本次项目积累了丰富的行业最佳实践和宝贵的知识库资源。</p>',
    'advantage-consult':'<h4>先进的咨询方法</h4>'+
                        '<p class="txt-info">运用场景化需求分析方法，专业化的用户体验和交互设计能力，提供高质量的需求服务。' +
                        '运用体系化的架构规划设计方法论，专业化的架构管控工具，擅长运用技术优势提升业务价值和客户体验，为本次项目成功实施落地提供强大保障</p>',
    'advantage-insight':'<h4>洞察系统情况</h4>'+
                        '<p class="txt-info">1.通过与各银行良好的项目合作和对银行业务运营的全方位理解，易于建立与全行上下无障碍沟通协作的工作基础；</p>'+
                        '<p>2.对银行的系统现状和IT架构有深刻洞察和了解，这将作为信息系统建设业务和IT有效衔接的坚实基础。</p>',

};
const honorAlt={
    ry1:'金华银行星云奖',
    ry2:'湖州银行最佳合作厂商',
    ry3:'浦发硅谷银行“新一代”工程最佳合作伙伴奖',
    ry4:'浦发硅谷银行“新一代”工程荣誉证书',
    ry5:'常熟农商优秀合作伙伴奖杯',
    ry6:'广州银行优秀服务奖牌',
    ry7:'张家港917新信贷项目-星耀蓝图奖杯',
    ry8:'嘉兴银行新核心系统项目群咨询服务项目最佳合作厂商证书',
    ry9:'嘉兴银行新核心系统项目群咨询服务项目最佳合作厂商奖杯',
    ry10:'嘉兴银行新核心系统项目群咨询服务项目特别贡献奖奖杯',
    ry11:'东莞银行2020年度外包供应商优秀服务奖',
    ry12:'张家港农商银行“820核心工程”最佳风采奖奖杯',
    ry13:'张家港农商银行“820核心工程”特别团队奖奖杯',
    ry14:'张家港农商银行“820核心工程”最佳合作厂商奖杯',
    ry15:'徽商银行“826工程”最佳合作伙伴奖奖杯',
    ry16:'郑州银行新一代项目优秀合作伙伴件',
    ry17:'南京银行“鑫云+”互联网金融平台优秀合作奖牌匾',
    ry18:'大连农商银行优秀合作伙伴奖',
    ry19:'南京银行新一代信息系统建设项目优秀协作奖牌匾',
    ry20:'广发银行信息系统建设“2012年度合作贡献奖',
  


};
const headH = $('.g-header').height();
const swiperTip= $('#swiperTip');

initialize();

function initialize(){
    scrollViewport('.screen', function ($screen) {
        let id= $screen.prop('id');
        if(id === 'technology' && !$screen.is('.active')){
            $('#xqsj').html('12');
            $('#ldss').html('27');
            $('#sjjr').html('3');
            $('#senior').html('12');
            $('#middle').html('14');
            $('#junior').html('32');
        }
        $screen.addClass('active').removeClass('disabled-animated');
    }, {
        delayDistance:200,
        onLeave: function ($screen) {
            let id= $screen.prop('id');
            if(id === 'technology' && $screen.is('.active')){
                $('#xqsj').html('00');
                $('#ldss').html('00');
                $('#sjjr').html('00');
                $('#senior').html('00');
                $('#middle').html('00');
                $('#junior').html('00');
            }
            $screen.removeClass('active');

        }
    });
    initAnchor();
    initAdvantage();
    window.onload= function(){
        initSwiper();
    };
}

/**
 * 锚点功能
 */
function initAnchor(){
    $('.anchor').on('click', function (e) {
        let $self = $(this),
            target = $self.data('target'),
            targetTop = $(target).offset().top;
        $('html,body').animate({scrollTop: targetTop-headH/2});
        e.preventDefault();
    });
}

/**
 * 优势目录切换功能
 */
function initAdvantage(){
    $('.advantage-catalog').on('click','.catalog-item',function(){
        $(this).siblings().removeClass('active').end().addClass('active');
        let value= $(this).data('value'),
            $advantageInfo= $('#advantageInfo'),
            infoImg= $advantageInfo.find('.info-img'),
            infoTxt= $advantageInfo.find('.info-txt');
        infoImg.removeClass(infoImg.data('target')).addClass(value).data('target',value).animateCss('fadeIn');
        infoTxt.html(advantageCatalog[value]);
    });
}

/**
 * 轮播图功能
 */
function initSwiper(){
    let mySwiper= $('.swiper-container').swiper({
        loop: true,
        slidesPerView: 'auto',
        centeredSlides:true,
        onlyExternal:true,
        loopedSlides:1,
        slidesPerGroup:3,
        cssWidthAndHeight : true,
        autoResize : false,
        onSlideChangeEnd(){
            let $swiperActive= $('.swiper-slide-active');
            swiperTip.text(honorAlt[$swiperActive.data('value')]);
            swiperTip.animateCss('fadeIn');
        }
    });
    $('.swiper').on('click','.prev',function(){
        mySwiper.swipePrev();
    }).on('click','.next',function(){
        mySwiper.swipeNext();
    });
}

$(window).resize(function(){
 // var h=$(".swiper-slide").find("img").height();
 // $(".swiper-wrapper,.swiper-slide").css("height",h)
})


// WEBPACK FOOTER //
// ./src/js/about.js